import React from 'react';
import styles from './OrderManagement.module.css';

interface TableWrapperProps {
    children: React.ReactNode;
}

const TableWrapper: React.FC<TableWrapperProps> = ({ children }) => (
    <div className={styles['table-wrap']}>
        <div className={styles['table-scroll']}>
            {children}
        </div>
    </div>
);

export default TableWrapper;